import { Button, Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IHeaderResources } from '../header.props.autogenerated';
import { renderTextWithCurlyBold } from '../../../utils';

type ISelectEventModalResources = Pick<
    IHeaderResources,
    'selectEventModalTitle' | 'selectEventModalBody' | 'selectEventModalButtonText' | 'selectEventModalButtonAriaLabel'
>;

export interface ISelectEventModalProps {
    isOpen: boolean;
    selectEventUrl: string;
    onClose: () => void;
    resources: ISelectEventModalResources;
    modalLogo: React.ReactNode;
}

export const SelectEventModal: React.FC<ISelectEventModalProps> = ({ isOpen, selectEventUrl, onClose, resources, modalLogo }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} className='ms-header__select-event-modal' keyboard={false} backdrop='static'>
            <div className='ms-header__select-event-modal__panel'>
                <ModalHeader className='ms-header__select-event-modal__header'>
                    <div className='ms-header__select-event-modal__header-logo'>{modalLogo}</div>
                </ModalHeader>
                <ModalBody className='ms-header__select-event-modal__body'>
                    <div className='ms-header__select-event-modal__icon' aria-hidden />
                    <h2 className='ms-header__select-event-modal__title'>{resources.selectEventModalTitle}</h2>
                    <p className='ms-header__select-event-modal__text'>
                        {renderTextWithCurlyBold(resources.selectEventModalBody, 'ms-header__select-event-modal__text-emphasis')}
                    </p>
                    <Button
                        className='ms-header__select-event-modal__button'
                        href={selectEventUrl}
                        aria-label={resources.selectEventModalButtonAriaLabel}
                    >
                        {resources.selectEventModalButtonText}
                    </Button>
                </ModalBody>
            </div>
        </Modal>
    );
};
